import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { Typography, Box } from '@mui/material';

const EloChart = ({ data }) => {
  if (!data || !Array.isArray(data) || data.length === 0) {
    return (
      <div style={{ width: '100%', height: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <p>No data available</p>
      </div>
    );
  }

  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      const year = date.getFullYear().toString();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const formattedDate = `${month}.${day}.${year}`;
      // Limit formatted date to 10 characters with ellipsis if needed
      return formattedDate.length > 10 ? formattedDate.substring(0, 10) + '...' : formattedDate;
    } catch (e) {
      return dateString.length > 10 ? dateString.substring(0, 10) + '...' : dateString;
    }
  };

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <div style={{ 
          backgroundColor: 'white', 
          padding: '8px', 
          border: '1px solid #ccc',
          borderRadius: '4px'
        }}>
          <p style={{ marginBottom: '4px', fontWeight: '500' }}>{data.course}</p>
          <p>ELO: {data.elo}</p>
          <p>Time: {formatDate(data.createDate)}</p>
        </div>
      );
    }
    return null;
  };
const CustomDot = (props) => {
    const { cx, cy, payload } = props;
    const isMax = payload.elo === maxElo;
    const isMin = payload.elo === minElo;

    if (isMax) {
      return (
        <g>
          {/* Outer highlight circle */}
          <circle
            cx={cx}
            cy={cy}
            r={10}
            fill="rgba(75, 85, 99, 0.2)"
            stroke="#7eff85"
            strokeWidth={5}
          />
          {/* Inner dot */}
          <circle
            cx={cx}
            cy={cy}
            r={5}
            fill="white"
            // stroke="#7eff85"
            strokeWidth={2}
          />
        </g>
      );
    } else if (isMin) {
        return (
            <g>
              {/* Outer highlight circle */}
              <circle
                cx={cx}
                cy={cy}
                r={10}
                fill="rgba(75, 85, 99, 0.2)"
                stroke="#ff907e"
                strokeWidth={5}
              />
              {/* Inner dot */}
              <circle
                cx={cx}
                cy={cy}
                r={5}
                fill="white"
                // stroke="#ff907e"
                strokeWidth={2}
              />
            </g>
          );
    }

    // Regular dot
    return (
        <></>
    );
  };

  const maxElo = Math.max(...data.map(item => Number(item.elo) || 0));
  const minElo = Math.min(...data.map(item => Number(item.elo) || 0));
  const yAxisMax = Math.ceil((maxElo + 50) / 100) * 100;
  const yAxisMin = Math.floor((minElo - 50) / 100) * 100;
  const yTickCount = ((yAxisMax - yAxisMin) / 100) + 1

  return (
    <div style={{ width: '100%', height: '400px', position: 'relative' }}>
        <Box display="flex" flexDirection="column" alignItems="center" sx={{ marginTop: 1 }}>
              <Typography variant="h6" sx={{ fontFamily: '"Press Start 2P", sans-serif', fontWeight: 'bold', fontSize: '1rem' }}>Elo Progress</Typography>
        </Box>

      <ResponsiveContainer width="100%" height={400}>
        <LineChart
          data={data}
          margin={{ top: 20, right: 30, left: 20, bottom: 50 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" fill='black' fillOpacity={0.6}/>
          <XAxis
            dataKey="createDate"
            tickFormatter={formatDate}
            tick={{ fill: '#6B7280' }}
            angle={-45}
            textAnchor="end"
            height={80}
            label={{ value: 'Date', position: 'insideBottom', offset: -10, style: { textAnchor: 'middle', fill: '#6B7280', fontSize: 14 } }}
          />
          <YAxis
            domain={[yAxisMin, yAxisMax]}
            tick={{ fill: '#6B7280' }}
            type='number'
            tickCount={yTickCount}
            width={35}
            label={{ value: 'ELO', angle: -90, position: 'insideLeft', dx: -12, style: { textAnchor: 'middle', fill: '#6B7280', fontSize: 14 } }}
          />
          <Tooltip content={<CustomTooltip />} />
          <Line
            type="monotone"
            dataKey="elo"
            stroke="#c9feff"
            strokeWidth={2}
            dot={<CustomDot />}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default EloChart;